// Data fetching
export const GET_DASHBOARD_TASKS_REQUEST = 'GET_DASHBOARD_TASKS_REQUEST';
export const GET_DASHBOARD_TASKS_SUCCESS = 'GET_DASHBOARD_TASKS_SUCCESS';
export const GET_DASHBOARD_TASKS_FAILURE = 'GET_DASHBOARD_TASKS_FAILURE';

export const GET_EXPENSE_FOLLOWUP_REQUEST = 'GET_EXPENSE_FOLLOWUP_REQUEST';
export const GET_EXPENSE_FOLLOWUP_SUCCESS = 'GET_EXPENSE_FOLLOWUP_SUCCESS';
export const GET_EXPENSE_FOLLOWUP_FAILURE = 'GET_EXPENSE_FOLLOWUP_FAILURE';

export const GET_RECURRING_PAYABLES_DASHBOARD_REQUEST = 'GET_RECURRING_PAYABLES_DASHBOARD_REQUEST';
export const GET_RECURRING_PAYABLES_DASHBOARD_SUCCESS = 'GET_RECURRING_PAYABLES_DASHBOARD_SUCCESS';
export const GET_RECURRING_PAYABLES_DASHBOARD_FAILURE = 'GET_RECURRING_PAYABLES_DASHBOARD_FAILURE';

export const GET_EXTERNAL_COMMENTS_REQUEST = 'GET_EXTERNAL_COMMENTS_REQUEST';
export const GET_EXTERNAL_COMMENTS_SUCCESS = 'GET_EXTERNAL_COMMENTS_SUCCESS';
export const GET_EXTERNAL_COMMENTS_FAILURE = 'GET_EXTERNAL_COMMENTS_FAILURE';

export const GET_EXCEPTION_COMMENTS_REQUEST = 'GET_EXCEPTION_COMMENTS_REQUEST';
export const GET_EXCEPTION_COMMENTS_SUCCESS = 'GET_EXCEPTION_COMMENTS_SUCCESS';
export const GET_EXCEPTION_COMMENTS_FAILURE = 'GET_EXCEPTION_COMMENTS_FAILURE';

// Task actions
export const UPDATE_TASK_REQUEST = 'UPDATE_TASK_REQUEST';
export const UPDATE_TASK_SUCCESS = 'UPDATE_TASK_SUCCESS';
export const UPDATE_TASK_FAILURE = 'UPDATE_TASK_FAILURE';

export const ATTEMPT_TASK_REQUEST = 'ATTEMPT_TASK_REQUEST';
export const ATTEMPT_TASK_SUCCESS = 'ATTEMPT_TASK_SUCCESS';
export const ATTEMPT_TASK_FAILURE = 'ATTEMPT_TASK_FAILURE';

export const COMPLETE_TASK_REQUEST = 'COMPLETE_TASK_REQUEST';
export const COMPLETE_TASK_SUCCESS = 'COMPLETE_TASK_SUCCESS';
export const COMPLETE_TASK_FAILURE = 'COMPLETE_TASK_FAILURE';

export const CANCEL_TASK_REQUEST = 'CANCEL_TASK_REQUEST';
export const CANCEL_TASK_SUCCESS = 'CANCEL_TASK_SUCCESS';
export const CANCEL_TASK_FAILURE = 'CANCEL_TASK_FAILURE';

export const CREATE_MANUAL_TASK_REQUEST = 'CREATE_MANUAL_TASK_REQUEST';
export const CREATE_MANUAL_TASK_SUCCESS = 'CREATE_MANUAL_TASK_SUCCESS';
export const CREATE_MANUAL_TASK_FAILURE = 'CREATE_MANUAL_TASK_FAILURE';

// Context data
export const GET_VOUCHER_CONTEXT_REQUEST = 'GET_VOUCHER_CONTEXT_REQUEST';
export const GET_VOUCHER_CONTEXT_SUCCESS = 'GET_VOUCHER_CONTEXT_SUCCESS';
export const GET_VOUCHER_CONTEXT_FAILURE = 'GET_VOUCHER_CONTEXT_FAILURE';

export const GET_LETTER_TEMPLATE_REQUEST = 'GET_LETTER_TEMPLATE_REQUEST';
export const GET_LETTER_TEMPLATE_SUCCESS = 'GET_LETTER_TEMPLATE_SUCCESS';
export const GET_LETTER_TEMPLATE_FAILURE = 'GET_LETTER_TEMPLATE_FAILURE';

// Get RC Files
export const GET_RC_FILES_REQUEST = 'GET_RC_FILES_REQUEST';
export const GET_RC_FILES_SUCCESS = 'GET_RC_FILES_SUCCESS';
export const GET_RC_FILES_FAILURE = 'GET_RC_FILES_FAILURE';

// Get Letter Templates
export const GET_LETTER_TEMPLATES_REQUEST = 'GET_LETTER_TEMPLATES_REQUEST';
export const GET_LETTER_TEMPLATES_SUCCESS = 'GET_LETTER_TEMPLATES_SUCCESS';
export const GET_LETTER_TEMPLATES_FAILURE = 'GET_LETTER_TEMPLATES_FAILURE';

// Get Task Comments
export const GET_TASK_COMMENTS_REQUEST = 'GET_TASK_COMMENTS_REQUEST';
export const GET_TASK_COMMENTS_SUCCESS = 'GET_TASK_COMMENTS_SUCCESS';
export const GET_TASK_COMMENTS_FAILURE = 'GET_TASK_COMMENTS_FAILURE';

// UI state
export const SET_DASHBOARD_FILTERS = 'SET_DASHBOARD_FILTERS';
export const SET_TASK_FILTERS = 'SET_TASK_FILTERS';
export const SET_EXPENSE_FILTERS = 'SET_EXPENSE_FILTERS';
export const SET_EXTERNAL_COMMENTS_FILTERS = 'SET_EXTERNAL_COMMENTS_FILTERS';
export const SET_EXCEPTION_COMMENTS_FILTERS = 'SET_EXCEPTION_COMMENTS_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';
export const SET_ACTIVE_MODAL = 'SET_ACTIVE_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
